export const logTokenUsageToApi = async (toolName: string, tokensUsed: number) => {
  try {
    const response = await fetch('/web-tools/de/app-api/tokentracking', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        toolName,
        tokensUsed,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // console.log('Token usage logged:', data);
    } else {
      const errorData = await response.json();
      console.error('Failed to log token usage:', errorData);
    }
  } catch (error) {
    console.error('Error in logTokenUsageToApi:', error);
  }
};
